import type { ReactElement } from 'react';

import { HomeHero } from './home-hero';

/**
 * 홈 / 랜딩 — 2026-09 리디자인.
 *
 * 히어로 한 섹션뿐이다. 레퍼런스(대형 타이포 위 기울어진 카드 3장 + 스크롤 연출)를
 * 흰 바탕으로 옮겼고, 카드가 곧 1차 오픈의 세 갈래(자료실·교육·도입 문의)로 보내는 입구다.
 * 와이어프레임 P-00 의 판매형 섹션(페르소나 레일·번들·FAQ 등)은 걷어냈다 — 1차 오픈에는
 * 팔 상품이 없어 빈 목록만 남는다. 필요해지면 git 이력에서 되살린다.
 */
export function HomePage(): ReactElement {
  return (
    <main>
      <HomeHero />
    </main>
  );
}
